import { BehaviorSubject }	from 'rxjs'
import {
	Component,
	NgZone
}														from '@angular/core'
import {
	ConfigService,
	MapService,
	StateService,
	UtilityService
}														from '../../'
import {
	HeaderConfig
}														from '../../'

@Component({
  selector:			'electra-header',
  styleUrls:		['./header.component.scss'],
  templateUrl:	'./header.component.html'
})
export class HeaderComponent {
	config:	HeaderConfig
	state:	any

	banner1				= ''
	banner2				= ''
	currentBanner = ''
	showBanner		= 2

	get bannerClass(): string {
		return this.configService.mobile ? '' : 'desktop';
	}

  constructor(public configService: ConfigService, public mapService: MapService, public stateService: StateService, public utilityService: UtilityService, public zone: NgZone) {
		configService.header.subscribe(data => { this.gotConfig(data) })
		stateService.header.subscribe(data => { this.gotState(data) })
	}

	gotConfig(config: HeaderConfig) {
		this.config = config

		if (config.geofence.length > 0) {
			setTimeout(t => {
				t.mapService.watchGeofence(config.geofence, image => { t.switchBanners(image) });
			}, 1000, this) // Timing is an issue to load initial banner image, watch out for this
		} else {
			this.banner1		= this.configService.getImage(config.banner)
			this.showBanner	= 1
		}
	}

	gotState(data: any) {
		this.state = data;
	}

	switchBanners(newBanner: string) {
		newBanner = newBanner.replace(' ', '_');

		this.zone.run(() => {
			if (newBanner !== this.currentBanner) {
				this.currentBanner = newBanner
				if (this.showBanner === 1) {
					this.banner2 = this.configService.getImage(newBanner);
					this.showBanner = 2;

					setTimeout((t) => {
					 t.banner1 = '';
					}, 250, this);
				} else {
					this.banner1 = this.configService.getImage(newBanner);
					this.showBanner = 1;

					setTimeout((t) => {
						t.banner2 = '';
					}, 250, this);
				}
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/header/header.component.ts